/**
 * Transforms R2 URLs to img.ugz.ai URLs to avoid CORS issues
 * 
 * @param url The image URL that might need transformation
 * @returns The transformed URL or the original if no transformation needed
 */
export const transformImageUrl = (url?: string): string | undefined => {
  if (!url) return undefined;
  
  if (url.includes("pub-a1df6f0fac0048fa854b3e1a7db8e6d2.r2.dev")) {
    // Extract the path part after the domain
    const urlParts = url.split("/");
    const pathParts = urlParts.slice(3); // Skip protocol and domain parts
    
    // Construct the new URL with the correct base
    return `https://img.ugz.ai/${pathParts.join("/")}`;
  }
  
  return url;
};

/**
 * Sets crossOrigin attribute for an image element to avoid CORS issues
 * 
 * @param img The image element to configure
 */
export const setupCrossOrigin = (img: HTMLImageElement): void => {
  img.crossOrigin = "anonymous";
};

/**
 * Creates a friendly error message for image loading errors
 * 
 * @param url The URL that failed to load
 * @param name Optional name of the actor or item
 * @returns A user-friendly error message
 */
export const getImageLoadErrorMessage = (url?: string, name?: string): string => {
  const nameDisplay = name ? ` for ${name}` : '';
  
  if (!url) {
    return `No image URL provided${nameDisplay}`;
  }
  
  if (url.includes("pub-a1df6f0fac0048fa854b3e1a7db8e6d2.r2.dev")) {
    return `CORS error: Image${nameDisplay} is using R2 domain. Please use img.ugz.ai domain instead.`;
  }
  
  return `Failed to load image${nameDisplay}. The image may be missing or there might be a network issue.`;
}; 